import { render, staticRenderFns } from "./documentsDisplay.vue?vue&type=template&id=4783b7ef"
import script from "./documentsDisplay.vue?vue&type=script&lang=js"
export * from "./documentsDisplay.vue?vue&type=script&lang=js"
import style0 from "./documentsDisplay.vue?vue&type=style&index=0&id=4783b7ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports